// 뉴스 페이지 번역
export default {
  list: {
    sectionLabel: '새로운 소식',
    title: '교회 소식',
    description: '우리 교회 공동체의 최신 소식, 행사, 이야기를 확인하세요.'
  },
  detail: {
    backToNews: '소식 목록으로',
    articleNotFound: '게시글을 찾을 수 없습니다.',
    shareArticle: '이 글 공유하기',
    linkCopied: '링크가 클립보드에 복사되었습니다!',
    moreArticles: '다른 소식',
    previous: '이전 글',
    next: '다음 글'
  }
};
